import React from 'react';
import { EventAccountSettings } from '../components/Settings';
import { useParams } from 'react-router';
import { DashboardLayout } from '../components/DashboardLayout';

type SettingsPageProps = {};

export const EventSettingsPage = (props: SettingsPageProps) => {
  const { eventAccountId } = useParams<{
    eventAccountId: string;
    eventId: string;
  }>();

  return (
    <DashboardLayout title="Settings">
      <EventAccountSettings eventAccountId={eventAccountId} />
    </DashboardLayout>
  );
};
